import React from 'react';
import LockIconSvg from '../../assets/images/icon-two-factor-setup.svg'
const LockIcon = () => (
    <img src={LockIconSvg} className="title-icon" alt="Lock icon" />
);

export default LockIcon;